import type { SxProps, Theme } from '@mui/material';

export const stepperComponentStyles = {
  container: (): SxProps<Theme> => ({
    width: '100%',
    minWidth: 0,
    maxWidth: '680px',
    mx: 'auto',
  }),
  mobileProgress: (theme: Theme): SxProps<Theme> => ({
    display: { xs: 'flex', sm: 'none' },
    minHeight: '44px',
    alignItems: 'center',
    justifyContent: 'center',
    m: 0,
    mb: 3,
    px: 2,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1,
    color: theme.palette.text.primary,
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: 1.4,
    textAlign: 'center',
  }),
  stepper: (theme: Theme): SxProps<Theme> => ({
    display: { xs: 'none', sm: 'flex' },
    width: '100%',
    minWidth: 0,
    maxWidth: '680px',
    mb: { xs: 3.5, sm: 4.5 },
    '& .MuiStepConnector-alternativeLabel': {
      top: '21px',
      left: 'calc(-50% + 31px)',
      right: 'calc(50% + 31px)',
    },
    '& .MuiStepConnector-line': {
      borderColor: theme.palette.divider,
    },
    '& .Mui-completed .MuiStepConnector-line': {
      borderColor: theme.palette.success.dark,
    },
    '& .MuiStepLabel-label': {
      mt: '10px !important',
      fontSize: '14px',
      fontWeight: 600,
    },
    '& .MuiStepLabel-label.Mui-active': {
      color: '#147df5',
      fontWeight: 700,
    },
    '& .MuiStepLabel-label.Mui-completed': {
      color: theme.palette.success.dark,
      fontWeight: 700,
    },
    '& .MuiStepButton-root:focus, & .MuiStepButton-root:active': {
      border: 'none !important',
      outline: 'none !important',
      boxShadow: 'none !important',
    },
    '& .MuiStepButton-root:focus-visible .MuiStepLabel-iconContainer': {
      outline: '3px solid rgba(0, 144, 250, 0.35)',
      outlineOffset: '3px',
      borderRadius: '50%',
    },
  }),
  stepNumber: (theme: Theme, active: boolean, completed: boolean): SxProps<Theme> => ({
    display: 'flex',
    width: '42px',
    height: '42px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    bgcolor: active ? '#147df5' : completed ? theme.palette.success.dark : theme.palette.grey[400],
    color: theme.palette.common.white,
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: 1,
  }),
};
